export default __webpack_public_path__ + "transfix-maps/icons/P.4869567b94751f5d2a084c2c2e3343a3.png";